import { render, staticRenderFns } from "./EmailSignatures.vue?vue&type=template&id=7d2dc757&scoped=true&"
import script from "./EmailSignatures.vue?vue&type=script&lang=js&"
export * from "./EmailSignatures.vue?vue&type=script&lang=js&"
import style0 from "./EmailSignatures.vue?vue&type=style&index=0&id=7d2dc757&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2dc757",
  null
  
)

export default component.exports